<template>
  <div class="review-sec specification-card">
    <div class="review-header">
      <h4>المواصفات</h4>
    </div>
    <div class="card-body">
      <div class="lisiting-featues">
        <div class="row">
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-1.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>نوع الهيكل</span>
              <h6>{{ carDetails?.car?.type }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-2.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>العلامة التجارية</span>
              <h6>{{ carDetails?.car?.brand?.name }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-3.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>ناقل الحركة</span>
              <h6>{{ carDetails?.car?.gear }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-4.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>نوع الوقود</span>
              <h6>{{ carDetails?.car?.fuel_type }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-5.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>الكيلومترات</span>
              <h6>{{ carDetails?.car?.mileage }}</h6>
            </div>
          </div>
          <!-- <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-6.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>نظام الدفع</span>
              <h6>دفع أمامي</h6>
            </div>
          </div> -->
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-7.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>سنة الصنع</span>
              <h6>{{ carDetails?.car?.year }}</h6>
            </div>
          </div>
          <!-- <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-8.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>مكيف الهواء</span>
              <h6>نعم</h6>
            </div>
          </div> -->
          <!-- <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-9.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>رقم الشاسيه (VIN)</span>
              <h6>غير متوفر</h6>
            </div>
          </div> -->
          <!-- <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-10.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>عدد الأبواب</span>
              <h6>4</h6>
            </div>
          </div> -->
          <!-- <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-11.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>الفرامل</span>
              <h6>ABS</h6>
            </div>
          </div> -->
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-12.svg"
                alt="Icon"
              />
            </div>
            <div class="featues-info">
              <span>سعة المحرك</span>
              <h6>{{ carDetails?.car?.engine_capacity }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-9.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>اللون الخارجى</span>
              <h6>{{ carDetails?.car?.color }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-10.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>حالة الطلاء</span>
              <h6>{{ carDetails?.car?.paint_condition }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-1.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>حالة الهيكل</span>
              <h6>{{ carDetails?.car?.vehicle_body }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-6.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>طريقة الدفع</span>
              <h6>{{ carDetails?.car?.payment_method }}</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-8.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>الحالة</span>
              <h6>
                {{ carDetails?.car?.rent_or_sale == "sale" ? "بيع" : "ايجار" }}
              </h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-12.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>العداد</span>
              <h6>{{ carDetails?.car?.kilometers }} كم</h6>
            </div>
          </div>
          <div
            class="featureslist d-flex align-items-center col-xl-3 col-md-4 col-sm-6"
          >
            <div class="feature-img">
              <img
                src="@/assets/img/specification/specification-icon-2.svg"
                alt="Icon"
              />
            </div>

            <div class="featues-info">
              <span>بلد الصنع</span>
              <h6>{{ carDetails?.car?.manufacturing_region }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    carDetails: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.featues-info {
  margin: 0 5px;
}
</style>
